import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, ArrowRight } from 'lucide-react';
export function Hero() {
  return <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden px-4 sm:px-6 lg:px-8 pt-20" data-id="element-137">
      {/* Background Effects */}
      <div className="absolute inset-0 z-0" data-id="element-138">
        <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-gold-500/10 rounded-full blur-[100px] animate-pulse" data-id="element-139" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-gold-600/10 rounded-full blur-[120px] animate-pulse delay-1000" data-id="element-140" />
        {/* Dark overlay for better text contrast */}
        <div className="absolute inset-0 bg-black/60 z-10" data-id="element-141" />
        {/* Background Image - Gold Smelting */}
        <div className="absolute inset-0 bg-cover bg-center opacity-30" style={{
        backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/iWKcWtQBvZoo5GCtrtr7Ws/62aa7f63a84cb44542d7a259.png)'
      }} data-id="element-142" />
      </div>

      {/* Grid Pattern Overlay */}
      <div className="absolute inset-0 z-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#D4A32B 1px, transparent 1px)',
      backgroundSize: '40px 40px'
    }} data-id="element-143"></div>

      <div className="relative z-20 max-w-5xl mx-auto text-center flex flex-col items-center" data-id="element-144">
        <motion.div initial={{
        opacity: 0,
        scale: 0.8
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8
      }} className="mb-8" data-id="element-145">
          <img src="https://cdn.magicpatterns.com/uploads/hVzgNEN2Eeix5JoWytq8hx/we.png" alt="Kings Gold Smelters Logo" className="w-32 h-32 md:w-48 md:h-48 object-contain drop-shadow-[0_0_15px_rgba(212,163,43,0.3)]" data-id="element-146" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gold-500/10 border border-gold-500/20 mb-6 backdrop-blur-sm" data-id="element-147">
          <MapPin className="w-4 h-4 text-gold-400" data-id="element-148" />
          <span className="text-gold-400 font-medium text-sm tracking-wide" data-id="element-149">
            Bagamoyo Road, Dar es Salaam, Tanzania
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="text-4xl md:text-6xl lg:text-7xl font-bold tracking-tight mb-6 text-white" data-id="element-150">
          KINGS GOLD SMELTERS
          <span className="block text-2xl md:text-4xl lg:text-5xl mt-2 font-light text-gold-100" data-id="element-151">
            COMPANY LIMITED
          </span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        width: 0
      }} animate={{
        opacity: 1,
        width: '100px'
      }} transition={{
        duration: 1,
        delay: 0.6
      }} className="h-1 bg-gradient-to-r from-transparent via-gold-500 to-transparent mb-8" data-id="element-152" />

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto font-light leading-relaxed mb-10" data-id="element-153">
          Professional Gold Smelting Services | On-Site & Mobile Smelting
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.8
      }} className="flex flex-col sm:flex-row gap-4 w-full justify-center" data-id="element-154">
          <a href="#contact" className="px-8 py-4 bg-gold-500 text-black font-bold rounded-sm hover:bg-gold-400 transition-colors flex items-center justify-center gap-2 text-lg" data-id="element-155">
            Book Smelting Service
            <ArrowRight className="w-5 h-5" data-id="element-156" />
          </a>
          <a href="#services" className="px-8 py-4 bg-transparent border border-white/20 text-white font-medium rounded-sm hover:bg-white/10 transition-colors flex items-center justify-center text-lg" data-id="element-157">
            Explore Services
          </a>
        </motion.div>
      </div>
    </section>;
}